import { PATHS } from 'config';

export const isOfficialDomain = url => {
  return url.includes('mochipay.xyz') || url.includes('pklotcorp.com');
};

export const openUrl = url => {
  if (url === '' || url === undefined) {
    return;
  }
  if (isOfficialDomain(url)) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
};

export const currentUrl = url => {
  const matchEnPath = window.location.pathname.match(/^\/en$|^\/en\//);
  if (matchEnPath !== null) {
    return `/en${url}`;
  } else {
    return url;
  }
};

export const chainStorePath = store => {
  switch (store) {
    case 'car-beauty':
      return currentUrl(PATHS.CAR_BEAUTY_STORES);
    case 'auto-repair':
      return currentUrl(PATHS.AUTO_REPAIR_STORES);
    case 'car-wash':
      return currentUrl(PATHS.CAR_WASH_STORES);
    case 'charging':
      return currentUrl(PATHS.CHARGING);
    default:
      return '';
  }
};
